import { render, staticRenderFns } from "./GeneralStatistics.vue?vue&type=template&id=38a16d5c"
import script from "./GeneralStatistics.vue?vue&type=script&lang=js"
export * from "./GeneralStatistics.vue?vue&type=script&lang=js"
import style0 from "./GeneralStatistics.vue?vue&type=style&index=0&id=38a16d5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports